import { Component, OnInit } from '@angular/core';

import { ConfigureService } from '@app/configure/services/configure.service';
import { SessionService } from '@app/core/services/session.service';
import { HelperService } from '@app/core/services/helper.service';
import { ModalService } from '@app/core/services/modal.service';

import { ModalAction } from '@app/core/models/modal-action.model';
import { Dealer } from '@app/core/models/dealer.model';
import { Modal } from '@app/core/models/modal.model';

@Component({
	selector: 'cng-welcome-modal',
	templateUrl: './welcome.component.html',
	styleUrls: ['./welcome.component.less'],
})
export class ConfigureWelcomeModalComponent implements OnInit {
	steps: { key: string; display_text: string }[];
	dealer: Dealer = this.session_service.getDealer();
	trust_messages: { text: string; gtm_label?: string }[];
	configure_data: any = this.configure_service.configure_data;
	step_mode: string = this.configure_service.getStepMode();

	constructor(
		private modal_service: ModalService,
		private configure_service: ConfigureService,
		public helper_service: HelperService,
		private session_service: SessionService
	) {
		const actionButton: ModalAction = new ModalAction({
			id: 'ready',
			name: `I'm Ready`,
			large: true,
			bias: 'positive',
			click: (): void => {
				this.modal_service.show([
					'configure',
					'customer-details',
					'vehicle',
					this.modal_service.data.vehicle_id,
				]);
			},
		});

		this.modal_service.setConfig(
			new Modal({
				name: 'welcome_modal',
				title: 'Welcome',
				actions: [actionButton],
			})
		);
	}

	ngOnInit(): void {
		this.steps = this.configure_data.steps_order;

		if (this.step_mode === 'part_exchange') {
			this.trust_messages = [
				{ text: `Get your instant valuation with ${this.steps.length} simple steps` },
				{ text: 'Enter your vehicle details' },
				{ text: 'Get your part exchange valuation!' },
			];
		} else {
			this.trust_messages = [
				{
					text: `${
						this.configure_service.isBuyNowEnabled() ? 'Buy now or reserve' : 'Reserve'
					} in minutes with ${this.steps.length} simple steps`,
				},
				{ text: 'Arrange a handover date for your new vehicle' },
			];

			if (this.dealer.reservation && this.dealer.reservation.refundable) {
				this.trust_messages.push({
					text: 'Fully refundable reservation fee',
					gtm_label:
						'refundable_reservation_message__engage_configure_welcome_modal__[Fully refundable reservation fee]',
				});
			}
		}
	}
}
